import React, { forwardRef } from "react";
import accessibleDropdown from "../AccessibleDropdown/AccessibleDropdown";
import { Link } from "react-router-dom";

const ReportsMenuList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      handleItemKeyDown,
      handleMenuItemClick,
      restrictHover,
      accessibilityValues,
      handleClick,
      popupClassName = { open: "", close: "", wrapperClass: "" },
    },
    ref,
  ) => {
    return (
      <>
        <div
          className={`popup_menu ${isOpen ? popupClassName.open : popupClassName.close}`}
        >
          <div
            id={accessibilityValues.ariaControls}
            role={accessibilityValues.ariaHaspopup}
            aria-label={accessibilityValues.ariaLabel}
            aria-labelledby={accessibilityValues.buttonId}
            ref={ref}
            className="settings_listitem_container"
          >
            {menuItems?.map((menuItem, index) => {
              return (
                <Link
                  aria-hidden={!isOpen}
                  key={menuItem?.key}
                  ref={(el) => (itemRefs.current[index] = el)}
                  role="menuitem"
                  to={"/settings"}
                  state={{
                    from: menuItem?.key,
                  }}
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                  className="listitem with_btn"
                  onClick={() => handleClick()}
                >
                  <div className="list_btn">
                    {menuItem?.image && (
                      <div className="icon_wrapper">
                        <img
                          className={
                            menuItem.customCls ? menuItem.customCls : ""
                          }
                          src={menuItem?.image}
                          alt=""
                        />
                      </div>
                    )}
                    <p className="listitem_text">{menuItem?.heading}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </>
    );
  },
);

export default accessibleDropdown(ReportsMenuList);
